import { DetectedObjectTypes } from 'types';

export enum DataExtractionDefinitionsActionTypes {
  SET_DATA_EXTRACTION_DEFINITIONS = '@@dataExtractionDefinitions/SET_DATA_EXTRACTION_DEFINITIONS',
  LOAD_DATA_EXTRACTION_DEFINITIONS = '@@dataExtractionDefinitions/LOAD_DATA_EXTRACTION_DEFINITIONS',
}

export interface DataExtractionDefinitionsState {
  detectedObjectTypes?: DetectedObjectTypes;
}
